import Button from './button';
import CnPrintBtn from './cn-print-btn';
import TableCellImage from './table-cell-image';
const bundle = [Button, CnPrintBtn, TableCellImage];
export default bundle;
